export enum Sizes {
  HERO = 'hero',
  TEASER = 'teaser',
  BANNER = 'banner',
  DOUBLE_BANNER = 'doubleBanner',
  PERSON = 'person',
  ARTICLE_IMAGE = 'articleImage',
  ARTICLE_CONTENT = 'articleContent',
  SIDEBAR = 'sidebar',
  FULL_WIDTH = 'fullWidth'
}

export const IMAGE_SIZES: PictureSizes = {
  hero: [
    {
      max: '(max-width: 320px)',
      size: 'w=560'
    },
    {
      max: '(max-width: 450px)',
      size: 'w=820'
    },
    {
      max: '',
      size: 'w=1400'
    }
  ],
  teaser: [
    {
      max: '(max-width: 450px)',
      size: 'h=600'
    },
    {
      max: '',
      size: 'h=800'
    }
  ],
  banner: [
    {
      max: '(max-width: 320px)',
      size: 'w=560'
    },
    {
      max: '(max-width: 450px)',
      size: 'w=820'
    },
    {
      max: '',
      size: 'w=920'
    }
  ],
  doubleBanner: [
    {
      max: '(max-width: 320px)',
      size: 'fit=fill&w=280&h=373'
    },
    {
      max: '(max-width: 450px)',
      size: 'fit=fill&w=400&h=533'
    },
    {
      max: '(max-width: 640px)',
      size: 'fit=fill&w=600&h=800'
    },
    {
      max: '(max-width: 900px)',
      size: 'fit=fill&w=860&h=1147'
    },
    {
      max: '',
      size: 'fit=fill&w=1200&h=1600'
    }
  ],
  person: [
    {
      max: '(max-width: 320px)',
      size: 'w=640'
    },
    {
      max: '(max-width: 450px)',
      size: 'w=900'
    },
    {
      max: '(max-width: 639px)',
      size: 'w=1280'
    },
    {
      max: '(max-width: 640px)',
      size: 'w=428'
    },
    {
      max: '(max-width: 900px)',
      size: 'w=600'
    },
    {
      max: '',
      size: 'w=934'
    }
  ],
  articleImage: [
    {
      max: '(max-width: 320px)',
      size: 'w=560'
    },
    {
      max: '(max-width: 450px)',
      size: 'w=820'
    },
    {
      max: '(max-width: 640px)',
      size: 'w=1200'
    },
    {
      max: '(max-width: 1024px)',
      size: 'w=1728'
    },
    {
      max: '',
      size: 'w=2160'
    }
  ],
  articleContent: [
    {
      max: '(max-width: 320px)',
      size: 'w=560'
    },
    {
      max: '(max-width: 450px)',
      size: 'w=820'
    },
    {
      max: '(max-width: 640px)',
      size: 'w=1200'
    },
    {
      max: '',
      size: 'w=1600'
    }
  ],
  sidebar: [
    {
      max: '(max-width: 320px)',
      size: 'w=640'
    },
    {
      max: '(max-width: 450px)',
      size: 'w=900'
    },
    {
      max: '(max-width: 640px)',
      size: 'w=1280'
    },
    {
      max: '(max-width: 900px)',
      size: 'w=1800'
    },
    {
      max: '(max-height: 300px)',
      size: 'h=600'
    },
    {
      max: '(max-height: 400px)',
      size: 'h=800'
    },
    {
      max: '(max-height: 500px)',
      size: 'h=1000'
    },
    {
      max: '(max-height: 600px)',
      size: 'h=1200'
    },
    {
      max: '(max-height: 700px)',
      size: 'h=1400'
    },
    {
      max: '(max-height: 800px)',
      size: 'h=1600'
    },
    {
      max: '(max-height: 900px)',
      size: 'h=1800'
    },
    {
      max: '(min-height: 901px)',
      size: 'h=2000'
    },
    {
      max: '',
      size: 'h=2000'
    }
  ],
  fullWidth: [
    {
      max: '(max-width: 320px)',
      size: 'w=620'
    },
    {
      max: '(max-width: 450px)',
      size: 'w=900'
    },
    {
      max: '(max-width: 640px)',
      size: 'w=1280'
    },
    {
      max: '(max-width: 1024px)',
      size: 'w=2048'
    },
    {
      max: '',
      size: 'w=2500'
    }
  ],
  heroSlide: [
    {
      max: '(max-height: 320px) and (max-width: 320px)',
      size: 'h=640'
    },
    {
      max: '(max-height: 400px) and (max-width: 400px)',
      size: 'h=800'
    },
    {
      max: '(max-height: 450px) and (max-width: 450px)',
      size: 'h=900'
    },
    {
      max: '(max-height: 500px) and (max-width: 500px)',
      size: 'h=1000'
    },
    {
      max: '(max-height: 600px) and (max-width: 600px)',
      size: 'h=1200'
    },
    {
      max: '(max-height: 700px) and (max-width: 700px)',
      size: 'h=1400'
    },
    {
      max: '(max-height: 800px) and (max-width: 800px)',
      size: 'h=1600'
    },
    {
      max: '(max-height: 900px) and (max-width: 900px)',
      size: 'h=1800'
    },
    {
      max: '',
      size: 'w=2500'
    }
  ]
};

interface Size {
  max: string;
  size: string;
}

interface PictureSizes {
  [key: string]: Array<Size>;
}
